/**
 * Created by roman.kupin on 10/07/2014.
 */

angular.module('flipto.components.touchpoints', ['flipto.core.lodash']);
